import store from "store";

const GLOBAL_KEY = "harpier";

export const storage = {
  set: (key: string, val: any) => {
    const data = store.get(GLOBAL_KEY) || {};

    data[key] = val;

    store.set(GLOBAL_KEY, data);
  },

  get: (key: string): any | null => {
    const data = store.get(GLOBAL_KEY) || {};

    if (data[key]) {
      return data[key];
    }

    return null;
  },

  delete: (key: string) => {
    const data = store.get(GLOBAL_KEY) || {};

    delete data[key];

    store.set(GLOBAL_KEY, data);
  },
};
